var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"word-cloud",staticStyle:{"height":"74.5vh","width":"96vw","margin":"0 auto","margin-top":"2vh"}},[_c('svg',{attrs:{"id":"wordcloud","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }